import { Task, TaskListItem, TaskStatus } from "@myapp/contract";
import { ISelectOption } from "../../../shared/types/ISelectOption";

export const NEEDS_RESCHEDULING_LABEL = "Braucht Umdisponierung";

const TASK_STATUS_LABELS: Record<TaskStatus, string> = {
  PLANNED: "Geplant",
  COMPLETED: "Abgeschlossen",
  DELAYED: "Verzögert",
  CANCELLED: "Storniert",
};

const IN_PROGRESS_LABEL = "In Bearbeitung";
const IN_PROGRESS_COLOR = "#ED9E42";

type TaskLike = Pick<Task | TaskListItem, 'status' | 'actualStart' | 'actualEnd'>

export const isTaskInProgress = (t: TaskLike): boolean =>
  t.status === 'PLANNED' && !!t.actualStart && !t.actualEnd;

export const getTaskStatusLabel = (
  status: TaskStatus,
  task?: TaskLike,
): string => {
  if (task && isTaskInProgress(task)) return IN_PROGRESS_LABEL;
  return TASK_STATUS_LABELS[status];
};

const TASK_STATUS_COLORS: Record<TaskStatus, string> = {
  PLANNED: "#2EB5D9",
  COMPLETED: "#3BC67D",
  DELAYED: "#ED9E42",
  CANCELLED: "#9CA3AF",
};

export const getTaskStatusColor = (
  status: TaskStatus,
  task?: TaskLike,
): string => {
  if (task && isTaskInProgress(task)) return IN_PROGRESS_COLOR;
  return TASK_STATUS_COLORS[status];
};

export const taskStatusOptions: ISelectOption[] = (
  Object.keys(TASK_STATUS_LABELS) as TaskStatus[]
).map((status) => ({ value: status, label: TASK_STATUS_LABELS[status] }));

export type StatusFilterValue = TaskStatus | "NEEDS_RESCHEDULING";

export const taskStatusFilterOptions: ISelectOption[] = [
  { value: "PLANNED", label: TASK_STATUS_LABELS.PLANNED },
  { value: "COMPLETED", label: TASK_STATUS_LABELS.COMPLETED },
  { value: "NEEDS_RESCHEDULING", label: NEEDS_RESCHEDULING_LABEL },
];
